export interface ManualTimePickerValue {
  timeString: string;
  ISOString: string | null;
}

export const getManualScheduledExecutionTime = (
  value: ManualTimePickerValue,
) => value.timeString || null;

export const getManualTimePickerValue = (value?: string | null) => {
  if (!value) return null;
  if (value.includes("T")) return value;
  return `${new Date().toISOString().slice(0, 10)}T${value}`;
};
